// extracted by mini-css-extract-plugin
export var active = "button-module--active--fdd87";
export var arrow = "button-module--arrow--33300";
export var arrow_white = "button-module--arrow_white--f26fd";
export var back = "button-module--back--7a852";
export var blue = "button-module--blue--62c46";
export var border = "button-module--border--1346b";
export var button = "button-module--button--9ad72";
export var corner = "button-module--corner--45ae9";
export var fill = "button-module--fill--049fe";
export var gray = "button-module--gray--b8f12";
export var l = "button-module--l--b0145";
export var m = "button-module--m--35626";
export var menu = "button-module--menu--ab6cd";
export var nav = "button-module--nav--0dbf9";
export var primary = "button-module--primary--05a0e";
export var s = "button-module--s--027b0";
export var secondary = "button-module--secondary--5068f";
export var square = "button-module--square--be89b";
export var text = "button-module--text--4c521";
export var white = "button-module--white--3f017";
export var white_noshadow = "button-module--white_noshadow--61e59";